import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { DateInput, TextInput, Select } from 'components/Inputs';

export const Label = styled.div`
  margin-bottom: 17px;
  text-decoration: none;
  font-size: 14px;
  position: relative;
  display: flex;

  :last-child {
    margin-bottom: 0;
    padding-right: 14px;
  }

  > svg {
    font-size: 18px;
    color: ${th('colors.turquoise')};
    cursor: pointer;
    margin-left: 12px;
  }
`;

export const EditableDateInput = styled(DateInput)`
  display: inline-block;
  margin-bottom: 0;
  flex: 1;

  > svg,
  > div > svg {
    display: none;
  }

  @media ${sizes.tabletPortrait} {
    bottom: -2px;
  }
`;

export const EditableTextInput = styled(TextInput)`
  display: inline-block;
  position: relative;
  flex: 1;
  margin-bottom: 0;

  > input {
    font-size: 14px;
    margin: 0;
    padding: 0;
    border: none;
  }

  :after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: ${th('colors.white')};
    position: absolute;
    bottom: -3px;
    left: 0;
  }
`;

export const SaveWrapper = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) =>
    disabled ? th('colors.pickledBluewood2') : th('colors.turquoise')};

  > svg {
    font-size: 18px;
    position: relative;
    top: 2px;
    margin-left: 10px;
  }

  > span {
    font-size: 14px;
    user-select: none;
    display: none;
  }

  @media ${sizes.tabletPortrait} {
    > span {
      display: inline-block;
    }

    > svg {
      font-size: 13px;
      margin-right: 4px;
    }
  }
`;

export const EditableSelect = styled(Select)`
  display: inline-block;
  margin-bottom: 0;
  flex: 1;
`;

export const Placeholder = styled.div`
  color: ${th('colors.turquoise')};
  text-decoration: underline;
  cursor: pointer;
`;
